import { useMutation } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";
import { useIntl } from "react-intl";

import { api } from "@/api/api";
import { showSnackbar } from "@/contexts/SnackbarContext";
import type { CreatePendingInstallmentInputDto } from "@/types/codegen";

export const useCreatePendingInstallment = () => {
  const intl = useIntl();

  return useMutation({
    mutationFn: (input: CreatePendingInstallmentInputDto) => {
      return api.post<
        void,
        AxiosResponse<void>,
        CreatePendingInstallmentInputDto
      >("/transactions/bnpl/create-pending-installment", input);
    },
    onError: () => {
      showSnackbar({
        type: "error",
        content: intl.formatMessage({
          defaultMessage:
            "Only one installment order is allowed per 24 hours. Please try again later.",
          description:
            "Error shown when a second installment order is attempted within 24 hours",
        }),
      });
    },
  });
};
